import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import auth from "~/modules/auth/store";
import functionalities from "~/modules/functionalities/store";
import customisation from "~/modules/customisation/store";
import notifications from "~/modules/notifications/store";
import {usersManagement} from "~/modules/users/store";


const store = new Vuex.Store({
  modules: {
    auth,
    customisation,
    functionalities,
    notifications,
    usersManagement
  },
})

store.dispatch("storeInit");

export default store;
